/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".add-group-checkboxes[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{padding:10px 36px;margin-top:0}@media (max-width:640px){.loginHelptext[_ngcontent-%COMP%]{width:83.33%}}\n/*# sourceMappingURL=register-user-form.component.css.map*/"];
export { styles as styles };
